const { addDays, subDays, addYears, subYears, addMonths, subMonths } = require('date-fns');
const { validate } = require('jsonschema');
const { FORM_MODE, DATE_STRINGS } = require('../constants');

/**
 * validate if field is null or undefineds
 * @param {*} value
 * @returns {boolean}
 */
const isNullOrUndefined = (value) => value == null;
const validateType = (value, informatedType, requiredValidation) =>
  validate(value, informatedType, requiredValidation).valid;

const valueAsNumber = (value) => parseInt(value, 10);
const valueAsFloat = (value) => parseFloat(value);
const valueAsObject = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return undefined;
  }
};

/**
 * validate if the field is empty
 * @param {(array | number | string | null | undefined)} value
 * @returns {boolean} if isEmpty or not
 */
const isEmpty = (value) =>
  ((valueAsNumber(value) || valueAsFloat(value)) && !value) ||
  value === '' ||
  isNullOrUndefined(value) ||
  (Array.isArray(value) && !value.length);

/**
 * validate if fieldValue contiains a letter or a number
 * @param {String} value field value
 * @returns {boolean} `true` or `false`
 */
const atLeastOneChar = (value) => {
  if (isNullOrUndefined(value)) return false;
  const regex = /^[a-zA-Z0-9]+$/;
  const re = new RegExp(regex);
  return !!re.test(value);
};

/**
 * validate if fieldValue contiains a number
 * @param {Number} value field value
 * @returns {boolean} `true` if constains or `false`
 */
const atLeastOneNumber = (value) => {
  if (isNullOrUndefined(value)) return false;
  const regex = /^[0-9]+$/;
  const re = new RegExp(regex);
  return !!re.test(value);
};

const isValidFloat = (value) => {
  if (isNullOrUndefined(value)) return false;
  const regex = /^-?\d+((\.)\d+(e\d+)?)?$/;
  const re = new RegExp(regex);
  return !!re.test(value);
};

const getCurrentMode = (value) => {
  let currentMode = '';
  Object.entries(FORM_MODE).forEach((mode) => {
    const [name, values] = mode;
    const isCurrentMode = values.includes(value.toLowerCase());
    if (isCurrentMode) {
      currentMode = name.toLowerCase();
    }
  });
  return currentMode;
};

const getDateTimeFunction = (unit, inc) => {
  if (unit === DATE_STRINGS.YEAR) {
    if (inc) return addYears;
    return subYears;
  }

  if (unit === DATE_STRINGS.MONTH) {
    if (inc) return addMonths;
    return subMonths;
  }

  if (unit === DATE_STRINGS.DAY) {
    if (inc) return addDays;
    return subDays;
  }
  return undefined;
};

const getValidationDate = (value, unit, inc) => {
  const currentDate = new Date();
  const dateFunc = getDateTimeFunction(unit, inc);
  return dateFunc(currentDate, value);
};

module.exports = {
  atLeastOneChar,
  atLeastOneNumber,
  getCurrentMode,
  getValidationDate,
  isEmpty,
  isNullOrUndefined,
  isValidFloat,
  validateType,
  valueAsFloat,
  valueAsNumber,
  valueAsObject,
};
